import { AGREEMENT_CREATED } from 'Common/constants';
import { currentStatusConsentOrders } from 'Common/Utils/documentStatus';

export const isConsentOrdersAgreedToStart = () =>
  currentStatusConsentOrders() === AGREEMENT_CREATED;
